import styled from 'styled-components';
import { VRadioGroupField } from 'welltrax-ui-components';

export const FieldSetContainer = styled.div`
  border: 1px solid #d3dae0;
  border-radius: 3px;
  position: relative;
  height: 31px;
  margin-top: 6px;
`;
export const FilterNavDispatchBoardContainer = styled.div`
  .bp3-navbar-group {
    height: auto !important;
    min-height: 50px;
  }
`;

export const LegendContainer = styled.div`
  position: absolute;
  left: 5px;
  font-size: 12px;
  top: -9px;
  padding: 0 5px;
  height: 10px;
  background-color: #fff;
`;

interface IFieldSetContent {
  bgColorIndicator: string;
}
export const FieldSetContent = styled.div`
  width: 200px;

  & input:checked ~ .bp3-control-indicator {
    background-color: ${(props: IFieldSetContent) => `${props.bgColorIndicator}!important`};
  }
`;

export const StyledRadioButton = styled(VRadioGroupField)`
  & .bp3-form-content {
    flex-direction: row;
    text-align: left;
    & label.field-label {
      width: 53% !important;
    }
    & div {
      display: flex;
      justify-content: center;
    }
    & .gsi-input-and-error-container {
      & div label:nth-child(1) {
        width: 50%;
      }
      label {
        display: inline;
      }
    }
  }

  @media (max-width: 482px) {
    & .bp3-form-content {
      flex-direction: column;
      & .gsi-input-and-error-container {
        & div label:nth-child(1) {
          width: 40%;
        }
      }
    }
  }
`;

export const VDateTimePickerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .arrow-left,
  .arrow-right {
    transition: transform 0.5s ease;
  }

  .arrow-left:hover,
  .arrow-right:hover {
    transform: scale(0.9);
  }
`;
